<template>
  <div class="main shadow" id="home">
    <div class="menu">
      <div class="logo">
        <router-link to="/block0">
          <img src="./img/logo.png" alt="" />
        </router-link>
      </div>
      <div class="menulist">



        <div class="item" >
          <img src="./img/nav-1.png" alt="" /><span>行车安全</span>
          <div class="submenu">
            <router-link to="/block1">用户须知</router-link>
            <router-link to="/block2">安全指南</router-link>
            <router-link to="/block3">安全注意事项</router-link>
            <router-link to="/block4">骑行注意事项</router-link>
            <router-link to="/block5">配件和改装</router-link>
            <router-link to="/block6">负载</router-link>
          </div>
        </div>


        <div class="item">
          <img src="./img/nav-2.png" alt="" /><span>操作指南</span>
          <div class="submenu">
            <router-link to="/block7">基本操作流程</router-link>
            <router-link to="/block8">零件位置</router-link>
            <router-link to="/block9">仪表</router-link>
            <router-link to="/block10">指示灯</router-link>
            <router-link to="/block11">开关</router-link>
            <router-link to="/block12">启动发动机</router-link>
            <router-link to="/block13">换挡</router-link>
            <router-link to="/block14">加油</router-link>
            <router-link to="/block15">存放设备</router-link>
          </div>
        </div>


        <div class="item">
          <img src="./img/nav-3.png" alt="" /><span>车辆保养</span>
          <div class="submenu">
            <router-link to="/block16">保养的重要性</router-link>
            <router-link to="/block17">保养周期表</router-link>
            <router-link to="/block18">保养规范</router-link>
            <router-link to="/block19">工具套件</router-link>
            <router-link to="/block20">拆卸和安装车身组件</router-link>
            <router-link to="/block21">火花塞</router-link>
            <router-link to="/block22">发动机机油</router-link>
            <router-link to="/block23">制动器</router-link>
            <router-link to="/block24">侧支架</router-link>
            <router-link to="/block25">驱动链条</router-link>
            <router-link to="/block26">离合器</router-link>
            <router-link to="/block27">油门</router-link>
            <router-link to="/block28">曲轴箱通气管</router-link>
            <router-link to="/block29">其他调整</router-link>
          </div>
        </div>


        <div class="item">
          <img src="./img/nav-4.png" alt="" /><span>故障处理</span>
          <div class="submenu">
            <router-link to="/block30">发动机无法启动</router-link>
            <router-link to="/block31">警告指示灯点亮</router-link>
            <router-link to="/block32">扎胎</router-link>
            <router-link to="/block33">电气故障</router-link>
            <router-link to="/block34">发动机间歇性工作不稳定</router-link>
          </div>
        </div>


        <div class="item">
          <img src="./img/nav-5.png" alt="" /><span>相关信息</span>
          <div class="submenu">
            <router-link to="/block35">钥匙</router-link>
            <router-link to="/block36">仪表、控件和其他功能</router-link>
            <router-link to="/block37">摩托车的养护</router-link>
            <router-link to="/block38">摩托车的存放</router-link>
            <router-link to="/block39">摩托车的运输</router-link>
            <router-link to="/block40">您与环境</router-link>
            <router-link to="/block41">车架号</router-link>
            <router-link to="/block41a">标牌</router-link>
            <router-link to="/block42">OBD 诊断接口</router-link>
            <router-link to="/block43">废气排放标准</router-link>
            <router-link to="/block44">含酒精燃料</router-link>
            <router-link to="/block45">催化转换器</router-link>
            <router-link to="/block45a">环境保护</router-link>
          
          </div>
        </div>




        <div class="item" @click="toBlock(46)">
          <img src="./img/nav-6.png" alt="" /><span>技术参数</span>
        </div>


      </div>
    </div>

    <div class="content">
      <!-- 搜索 -->
      <form class="getsearch">
        <div class="searchinput">
          <input type="text" class="search" placeholder="   关键字搜索" />
          <div class="submit"></div>
        </div>
      </form>
      <!-- 搜索 -->
      <div class="menu">
        <div class="title">
          <div class="menubutton"><img src="./img/menubutton.png" /></div>
          <div>使用说明书</div>
          <div class="searchbutton">
            <img src="./img/menusearch.png" width="43" height="43" />
          </div>
        </div>
        <div class="getsearch">
          <div class="searchcontent">
            <input type="text" value="" /><img
              src="./img/search-icon.png"
              alt=""
              class="leftsearch"
            /><img src="./img/delete-icon.png" alt="" class="rightsearch" />
            <div class="submit">搜索</div>
          </div>
        </div>


        <!--手机菜单 -->
        <div class="menucontent">

          <!--左边的菜单-->
          <div class="leftm">
            <div class="item"><img src="./img/nav-7.png" alt="" /><span>行车安全</span></div>
            <div class="item"><img src="./img/nav-8.png" alt="" /><span>操作指南</span></div>
            <div class="item"><img src="./img/nav-9.png" alt="" /><span>车辆保养</span></div>
            <div class="item"><img src="./img/nav-10.png" alt="" /><span>故障处理</span></div>
            <div class="item"><img src="./img/nav-11.png" alt="" /><span>相关信息</span></div>
            <div class="item" @click="toBlock(46)"><img src="./img/nav-12.png" alt="" /><span>技术参数</span></div>
          </div>


          <!--右边的菜单-->
          <div class="rightm">

            <div class="submenu">
              <router-link to="/block1">用户须知</router-link>
              <router-link to="/block2">安全指南</router-link>
              <router-link to="/block3">安全注意事项</router-link>
              <router-link to="/block4">骑行注意事项</router-link>
              <router-link to="/block5">配件和改装</router-link>
              <router-link to="/block6">负载</router-link>
              
            </div>

            <div class="submenu">
              <router-link to="/block7">基本操作流程</router-link>
              <router-link to="/block8">零件位置</router-link>
              <router-link to="/block9">仪表</router-link>
              <router-link to="/block10">指示灯</router-link>
              <router-link to="/block11">开关</router-link>
              <router-link to="/block12">启动发动机</router-link>
              <router-link to="/block13">换挡</router-link>
              <router-link to="/block14">加油</router-link>
              <router-link to="/block15">存放设备</router-link>
            </div>

            <div class="submenu">
              <router-link to="/block16">保养的重要性</router-link>
              <router-link to="/block17">保养周期表</router-link>
              <router-link to="/block18">保养规范</router-link>
              <router-link to="/block19">工具套件</router-link>
              <router-link to="/block20">拆卸和安装车身组件</router-link>
              <router-link to="/block21">火花塞</router-link>
              <router-link to="/block22">发动机机油</router-link>
              <router-link to="/block23">制动器</router-link>
              <router-link to="/block24">侧支架</router-link>
              <router-link to="/block25">驱动链条</router-link>
              <router-link to="/block26">离合器</router-link>
              <router-link to="/block27">油门</router-link>
              <router-link to="/block28">曲轴箱通气管</router-link>
              <router-link to="/block29">其他调整</router-link>
            </div>

            <div class="submenu">
              <router-link to="/block30">发动机无法启动</router-link>
              <router-link to="/block31">警告指示灯点亮</router-link>
              <router-link to="/block32">扎胎</router-link>
              <router-link to="/block33">电气故障</router-link>
              <router-link to="/block34">发动机间歇性工作不稳定</router-link>
            </div>

            <div class="submenu">
              <router-link to="/block35">钥匙</router-link>
              <router-link to="/block36">仪表、控件和其他功能</router-link>
              <router-link to="/block37">摩托车的养护</router-link>
              <router-link to="/block38">摩托车的存放</router-link>
              <router-link to="/block39">摩托车的运输</router-link>
              <router-link to="/block40">您与环境</router-link>
              <router-link to="/block41">车架号</router-link>
              <router-link to="/block45a">环境保护</router-link>
              
            </div>

            <!--如果菜单没有内容，用空的submenu-->
            <div class="submenu"></div>


          </div>
        </div>
      </div>
      <div class="maincontent">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted(){
    let self = this;
    $(".getsearch .submit").each(function(i, item){
      $(item).click(function(){
        let str = $(this).parent().find("input").val().replace(/ /g, "");
        if(str){
          self.$router.push({path:"/search",query:{search:str}});
        }
      })
    });
  },
  methods: {
    toBlock(bno) {
      $(".main .content .menu .menucontent").hide();
      $(".main .content .menu").removeClass("active");
      $(".main .content .maincontent").show();
      if(this.$route.path != "/block" + bno){ this.$router.push("/block" + bno); }
    }
  }
};
</script>
<style>
@import url(./css/honda.css);
@import url(./css/layout.css);
</style>
